module["exports"] = {
  "adjective": [
    "Balaca",
    "Ergonomik",
    "Kobud",
    "İntellektual",
    "Möhtəşəm",
    "İnanılmaz",
    "Fantastik",
    "Əlverişli",
    "Parlaq",
    "Mükəmməl"
  ],
  "material": [
    "Polad",
    "Ağac",
    "Beton",
    "Plastik",
    "Pambıq",
    "Qranit",
    "Rezin"
  ],
  "product": [
    "Stul",
    "Avtomobil",
    "Kompyuter",
    "Beret",
    "Kulon",
    "Stol",
    "Sviter",
    "Kəmər",
  ]
};



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/commerce/product_name.js
// module id = 176
// module chunks = 0